import * as React from 'react'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import { useMutation } from '@apollo/react-hooks'

import { DELETE_CREDIT_CARD } from '../../../../mutations/DeleteCreditCard'
import { client as apolloClient } from '../../../ApolloProvider/ApolloProvider'

import { H4 } from '../../BrandDashboardPayments/BrandDashboardPayments.style'

import DefaultButton from '../DefaultButton/DefaultButton'

import { AddedBy, CreditWrapper } from './CreditCards.style'

export const CreditCards: React.FC<{ isLimited: boolean; cards: any[] }> = ({
  isLimited,
  cards,
}) => {
  const [removeCreditCard] = useMutation(DELETE_CREDIT_CARD, {
    client: apolloClient,
  })
  const onRemoveCard = id => {
    removeCreditCard({
      variables: {
        creditCardId: id,
      },
    })
  }
  return (
    <>
      {cards &&
        cards.map(card => {
          const switchView = () => {
            switch (card.cardBrand) {
              case 'Visa':
                return `https://res.cloudinary.com/ninety-seconds/image/upload/v1569212781/-homepage-icons/-footer/icon-visa.svg`
              case 'MasterCard':
                return `https://res.cloudinary.com/ninety-seconds/image/upload/v1569212781/-homepage-icons/-footer/icon-mastercard.svg`
              case 'American Express':
                return `https://res.cloudinary.com/ninety-seconds/image/upload/v1572919213/-icons-emails-newsletters-communications/-brand-logos/logo-american-express.png`
            }
            return ''
          }
          if (isLimited ? card.permission === 'all' : card.permission === 'limited') {
            return
          }
          return (
            <CreditWrapper key={card.id}>
              <div>
                <H4>
                  <img src={switchView()} alt={card.cardBrand} /> **** **** **** {card.last4Digits}
                </H4>
                <AddedBy>
                  Added BY:{' '}
                  <strong>{card.owner && card.owner.firstName + card.owner.lastName}</strong>
                </AddedBy>
              </div>
              <DefaultButton
                fontSize="0.875rem"
                padding="0 1rem"
                backgroundColor={colors.alert}
                borderColor={colors.alert}
                color="white"
                buttonHeight="2rem"
                rounded
                hoverBackground={colors.alert}
                hoverColor="white"
                onClick={() => card.id && onRemoveCard(card.id)}
              >
                Remove
              </DefaultButton>
            </CreditWrapper>
          )
        })}
    </>
  )
}



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/CreditCards/CreditCards.tsx